import DQS from './DynamicQuantitySelect';

export const DynamicQuantitySelect = DQS;
export default DQS;
